import { workLogsMutate } from "@/api/logs/useWorksLogsQuery";
import useFetcher from "@/hooks/useFetcher";

export const useCheckDefectLotsFetcher = (equipmentCode?: string) => {
  const result = useFetcher(
    {
      queryKey: ["defectLots", equipmentCode],
      queryFn: async () => {
        if (!equipmentCode) throw new Error("equipmentCode is required");
        const result = await workLogsMutate
          .checkDefectLots({
            workLogsCheckDefectLotPostRequest: { equipmentCode },
          })
          .mutationFn(undefined);
        return result?.data; // 필요한 형태만 반환
      },
    },
    {
      enabled: !!equipmentCode,
      staleTime: 1000 * 60 * 5, // optional: 캐싱 시간
    }
  );

  return {
    ...result,
  };
};
